$(document).ready(function(){
// modal
 
$(".product-single.product_single_block .thumbnails-wrapper ul li img.product-single__thumbnail-image").click(function(){
  var thumb_img = $(this).attr("img_src");
  $(".product-single__photo-wrapper.js .product-single__photo img.feature-row__image.product-featured-img").attr("data-srcset", ''); 
  $(".product-single__photo-wrapper.js .product-single__photo img.feature-row__image.product-featured-img").attr("srcset", ''); 
  $(".product-single__photo-wrapper.js .product-single__photo img.feature-row__image.product-featured-img").attr("src", thumb_img); 
 
})

$(".product-single__photo-wrapper.js .product-single__photo img.feature-row__image.product-featured-img").click(function(){
  var main_img = $(this).attr("src");
  $("#main-img_modal").attr("src", main_img);
  $(".main_img_modal").show();
})

$(".controls i.fa.fa-close, .main_img_modal .modal_overlay").click(function(){
  $(".main_img_modal").hide();
})


// Get the modal (for product image navigation)
var modal = $(".main_img_modal");

// Get the image and insert it inside the modal
$('.product-featured-img').click(function(){
    var modalImg = $(".main-img_container #main-img_modal");
    var images = $('.product-single__thumbnail-image');
    var currentIndex = images.index($(this));
    var numImages = images.length;

    var prod_img_src = $(this).attr("data-srcset");
    var prod_img_src =  prod_img_src.split(',');
    var prod_img_src = prod_img_src[2];
  
    modal.css("display", "block");
    modalImg.attr("src", prod_img_src);

    // Next and previous buttons functionality
    $('.next').off('click').on('click', function() {
        currentIndex = (currentIndex + 1) % numImages;
        modalImg.attr("src", images.eq(currentIndex).attr("img_src"));
    });

    $('.prev').off('click').on('click', function() {
        currentIndex = (currentIndex - 1 + numImages) % numImages;
        modalImg.attr("src", images.eq(currentIndex).attr("img_src"));
    });
});


// Get the <span> element that closes the modal
var span = $(".controls")[0];

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
    modal.css("display", "none");
}
  
 
})


   